import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Zanimanje } from './zanimanje';

@Component({
  selector: 'yt-zanimanje-modal-update',
  templateUrl: './zanimanje-modal-update.component.html'
})
export class ZanimanjeModalUpdateComponent extends BaseModalUpdateComponent<Zanimanje> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Zanimanje>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
